<template>
    <!-- 新增编辑检验项目 -->
    <div class="add-dialog">
        <el-dialog :title="title" :visible.sync="dialogVisible" v-if="dialogVisible" width="50%" v-loading="loading"
            :close-on-click-modal='false'>
            <div class="header">
                <p></p>
                <h1>基础信息</h1>
            </div>
            <div class="content">
                <el-form ref="form" :rules="rules" :model="form" label-width="170px" size='small'>
                    <el-form-item label="检验类别大类：" prop='firstCategoryId'>
                        <el-select class="form-width" v-model="form.firstCategoryId" placeholder="请选择检验类别大类"
                            @change="categoryNameChange" clearable>
                            <el-option v-for="(item, index) in drugArr" :key="index" :label="item.categoryName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="检验类别小类：" prop='secondCategoryId'>
                        <el-select class="form-width" v-model="form.secondCategoryId" placeholder="请选择检验类别小类"
                            @input="change($event)" clearable>
                            <el-option v-for="(item, index) in drugArrTwo" :key="index" :label="item.categoryName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="检验项目编码：" prop='code'>
                        <el-input class="form-width" v-model="form.code" placeholder="请输入检验项目编码" clearable
                            onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="检验项目简称：" prop='abbreviation'>
                        <el-input class="form-width" v-model="form.abbreviation" placeholder="请输入检验项目简称"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="检验项目全称：" prop='name'>
                        <el-input class="form-width" v-model="form.name" placeholder="请输入检验项目全称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="检验结果属性：" prop='resultProperty'>
                        <el-radio-group v-model="form.resultProperty">
                            <el-radio :label="0">定性</el-radio>
                            <el-radio :label="1">定量</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="参考值范围：">
                        <div style="display:flex">
                            <el-input v-model="form.mixReference" style="width:21%" placeholder="请输入最小值"
                                clearable></el-input>
                            <span style="margin:0px 20px">-</span>
                            <el-input v-model="form.maxReference" style="width:21%" placeholder="请输入最大值"
                                clearable></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="检验定量结果计量单位：" prop='doseUnit' v-if="form.resultProperty == 1">
                        <el-input class="form-width" v-model="form.doseUnit" placeholder="请输入检验定量结果计量单位"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="是否启用：" prop='status'>
                        <el-radio-group v-model="form.status">
                            <el-radio :label="false">是</el-radio>
                            <el-radio :label="true">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input class="form-width" type="textarea" v-model="form.remark" clearable></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" style="width:110px"
                    @click="form = {}; title = '新增检验项目'; btn_1 = true; btn_2 = false">重置</el-button>
                <el-button size="small" type="primary" v-if="btn_1" @click="onSubmit"
                    style="width:110px;">保存</el-button>
                <el-button size="small" type="primary" v-if="btn_2" @click="editSubmit"
                    style="width:110px;">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { apiStandardInfoUpdate, apiAddInspection, apiUpdateInspection } from '../../../case-3/api/index'
export default {
    data() {
        return {
            dialogVisible: false,//弹窗
            form: { status: false, resultProperty: 1 },//表单数据
            title: "新增检验项目",//标题
            drugArr: [],
            drugArrTwo: [],
            btn_1: true,
            btn_2: false,
            loading: false,
            rules: {
                firstCategoryId: [
                    { required: true, message: '请选择检验类别', trigger: 'blur' },
                ],
                secondCategoryId: [
                    { required: true, message: '请选择检验类别', trigger: 'blur' },
                ],
                // code:[
                //   { required: true, message: '请输入检查项目编码', trigger: 'blur' },
                // ],
                // abbreviation:[
                //   { required: true, message: '请输入项目简称', trigger: 'blur' },
                // ],
                name: [
                    { required: true, message: '请输入项目全称', trigger: 'blur' },
                ],
                resultProperty: [
                    { required: true, message: '请输入检验定量结果计量单位', trigger: 'blur' },
                ],
                status: [
                    { required: true, message: '请选择是否启用', trigger: 'blur' },
                ],
            },
        }
    },
    methods: {
        /**
         * @description:  打开弹窗
         * @param {*}
         * @return {*}
        */
        openDialog() {
            this.form = { status: false, resultProperty: 1 }
            this.title = '新增检验项目'
            this.btn_1 = true
            this.btn_2 = false
            this.dialogVisible = true
            this.loading = false
            apiStandardInfoUpdate({
                status: false,
                type: 2,
                parentId: 0,
            }).then(res => {
                this.drugArr = res.data
            })
        },
        /**
         * @description:  根据选择的大类 获取小类
         * @param {*}
         * @return {*}
        */
        categoryNameChange(val) {
            apiStandardInfoUpdate({
                status: false,
                type: 2,
                parentId: val,
            }).then(res => {
                this.drugArrTwo = res.data
                this.form.secondCategoryId = ""
            })
        },
        /**
         * @description:  新建保存接口
         * @param {*}
         * @return {*}
        */
        onSubmit() {
            this.$refs.form.validate((valid) => {
                this.loading = true
                if (valid) {
                    apiAddInspection({ ...this.form }).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.$parent.getTestList()
                            this.loading = false
                            this.dialogVisible = false
                        } else {
                            this.loading = false
                            this.$message.error(res.message);
                        }
                    }).catch(e => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                    return false;
                }
            });
        },
        /**
        * @description:  编辑打开弹窗
        * @param {*}
        * @return {*}
       */
        editProject(row) {
            apiStandardInfoUpdate({
                status: false,
                type: 2,
                parentId: 0,
            }).then(res => {
                this.drugArr = res.data
            })
            apiStandardInfoUpdate({
                status: false,
                type: 2,
                parentId: row.firstCategoryId,
            }).then(res => {
                this.drugArrTwo = res.data
            })
            this.btn_2 = true
            this.btn_1 = false
            this.title = '编辑检验项目'
            this.dialogVisible = true
            this.form = { ...row }
        },
        /**
         * @description:  编辑保存表单
         * @param {*}
         * @return {*}
        */
        editSubmit() {
            this.$refs.form.validate((valid) => {
                this.loading = true
                if (valid) {
                    apiUpdateInspection({ ...this.form }).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: '成功',
                                type: 'success'
                            });
                            this.loading = false
                            this.$parent.getTestList()
                            this.dialogVisible = false
                        } else {
                            this.$message.error(res.message);
                            this.loading = false
                        }
                    }).catch(e => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                    return false;
                }
            });

        },
        //el数据input 无法输入解决办法
        change(e) {
            this.$forceUpdate();
        },
    },
}
</script>

<style lang="less" scoped>
.header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    p {
        width: 4px;
        height: 15px;
        background: #1A7BFC;
        margin-right: 12px;
    }

    h1 {
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
    }
}

.add-dialog {
    .title {
        font-size: 14px;
        color: #000;
        border-left: 4px solid #1A7BFC;
        padding-left: 10px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .content {
        width: 100%;
    }
}

.form-width {
    width: 90%;
}

/deep/.el-dialog__body {
    padding-top: 0;
}

/deep/.el-dialog__title {
    font-weight: 26px;
    color: #333;
    font-weight: bold;
}

/deep/.el-dialog__footer {
    text-align: center;
}
</style>
